/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Presentation from '@/components/Presentation';
import Earth from '@/components/Earth';
import XR from '@/components/XR/XR';
import auth from '../app/auth';
import LogoutSuccess from '@/components/LogoutSuccess';
import UserInfoStore from '../app/user-info-store';
import UserInfoApi from '../app/user-info-api';
import ErrorComponent from '@/components/Error';
import NFTVideoTestFullScreen from '@/components/Blockchain/NFTVideoTestFullScreen';
import SensorDashboard from '@/components/SensorDashboard/SensorDashboard';
import AquacultureDashboard from '@/components/Aquaculture/AquacultureDashboard';
import CalendarTest from '@/components/CalendarTest';

Vue.use(Router)

function requireAuth(to, from, next) {
  
  if (!auth.auth.isUserSignedIn()) {
      UserInfoStore.setLoggedIn(false);
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
  } else {
    UserInfoApi.getUserInfo().then(response => {
      UserInfoStore.setLoggedIn(true);
      UserInfoStore.setCognitoInfo(response);

      // Restricted LifeLink User Check
      var user = UserInfoStore.state.cognitoInfo.username;
      var restrictedLifeLinkUserList = [
        //"whoskin@vitrafy.com",
      ]
      if(restrictedLifeLinkUserList.includes(user)) {
        UserInfoStore.setRestrictedLifeLinkUser(true);
      }

      next();
    });
      
  }
}

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/workflow',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth
    },      
    {
      path: '/lifelink',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/workflow',
      name: 'home',
      component: Home,
      beforeEnter: requireAuth
    },             
    {
      path: '/calendarTest',
      name: 'CalendarTest',
      component: CalendarTest,
      beforeEnter: requireAuth
    },    
    {
      path: '/presentation',
      name: 'Presentation',
      component: Presentation,
      beforeEnter: requireAuth
    },
    {
      path: '/nftvideotestfullscreen',
      name: 'NFTVideoTestFullScreen',
      component: NFTVideoTestFullScreen,
      beforeEnter: requireAuth
    },
    {
      path: '/SensorDashboard',
      name: 'sensor-dashboard',
      component: SensorDashboard,
      beforeEnter: requireAuth
    }, 
    {
      path: '/AquacultureDashboard',
      name: 'aquaculture-dashboard',
      component: AquacultureDashboard,
      beforeEnter: requireAuth
    },        
    {
      path: '/earth',
      name: 'Earth',
      component: Earth,
      beforeEnter: requireAuth
    },
    {
      path: '/xr',
      name: 'XR',
      component: XR,
      beforeEnter: requireAuth
    },
    {
      path: '/static/demo',
      beforeEnter: requireAuth
    },      
    {
      path: '/login', beforeEnter(to, from, next){
        auth.auth.getSession();
      }
    },
    {
      path: '/login/oauth2/code/cognito', beforeEnter(to, from, next){
        var currUrl = window.location.href;
        auth.auth.parseCognitoWebResponse(currUrl);
      }
    },
    {
      path: '/logout', component: LogoutSuccess,  beforeEnter(to, from, next){
        auth.logout();
        next();
      }
    },
    {
      path: '/error', component: ErrorComponent
    }
  ]
})
